import axios from './../plugins/private-api-axios'

export const eventAlertUserNotificationService = {
    urlPrefix: '/eventAlertUserNotifications',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getEventAlertUserNotifications (vehicleId) {
        try {
            return await axios.get(`${this.urlPrefix}?vehicleId=${vehicleId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async createEventAlertUserNotifications (userId, vehicleId) {
        try {
            return await axios.post(`${this.urlPrefix}?vehicleId=${vehicleId}`, {
                userId: userId,
                vehicleId: vehicleId,
                emailNotification: true
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async deleteEventAlertUserNotifications (userId) {
        try {
            return await axios.delete(`${this.urlPrefix}/${userId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateEventAlertUserNotificationService = (accessToken) => {
    eventAlertUserNotificationService.config.headers.Authorization = accessToken
}

export default eventAlertUserNotificationService
